//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState } from 'vuex';

export default {
  props: {
    value: { type: Boolean, default: false },
  },
  data() {
    return {
      input: {},
    };
  },

  computed: {
    ...mapState('common', ['generalConfirm']),

    model: {
      get() {
        const { value } = this;
        return value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },

    isConfirmDisabled() {
      const { input } = this;
      return input.email
      && input.password
      && input.orgName
      && input.address
      && input.inn
      && input.kpp
      && input.phoneNumber;
    },
  },

  methods: {
    ...mapActions('common', [
      'setGeneralLoader',
      'setSuccessNotification',
      'setErrorNotification',
    ]),
    ...mapActions('cryptomatsRenters', {
      createRenterAction: 'createRenter',
    }),

    async confirm() {
      this.setGeneralLoader(true);
      try {
        await this.createRenterAction(this.input);
        this.setSuccessNotification('Renter created');
      } catch (error) {
        this.setErrorNotification('Unable to create renter');
      } finally {
        this.setGeneralLoader(false);
      }
    },
  },
};
